import Component from 'gia/Component';

export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      mobileMenu: {},
      buttonOpenMenu: {},
      buttonCloseMenu: {},
      openLocationModalButton: {},
      locationModal: {},
      locationModalInner: {},
      profileDropdown: {},
      profileButton: {}
    };
  }

  mount() {
    let that = this;

    console.log('mounted');

    this.ref.openLocationModalButton.addEventListener('click', function() {
      that.openLocationModal();
    });

    // this.ref.locationModalInner.addEventListener('click', function(event) {
    //   event.stopPropagation();
    // });

    document.addEventListener('click', function(event) {
      if (!that.ref.locationModalInner.contains(event.target) && !that.ref.openLocationModalButton.contains(event.target)) {
        that.closeLocationModal();
      }
    });

    if (this.ref.profileButton) {

      this.ref.profileButton.addEventListener('click', function(event) {
        that.ref.profileDropdown.classList.toggle('hidden');
      })
    }



    this.ref.buttonOpenMenu.addEventListener('click', function() {
      that.ref.mobileMenu.classList.remove('hidden');
      that.ref.buttonOpenMenu.classList.add('hidden');
      that.ref.buttonCloseMenu.classList.remove('hidden');
    });

    this.ref.buttonCloseMenu.addEventListener('click', function() {
      that.ref.mobileMenu.classList.add('hidden');
      that.ref.buttonOpenMenu.classList.remove('hidden');
      that.ref.buttonCloseMenu.classList.add('hidden');
    });
  }

  openLocationModal() {
    this.ref.locationModal.classList.remove('hidden');
  }

  closeLocationModal() {
    this.ref.locationModal.classList.add('hidden');
  }
}